<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady">
  <div class="row additem-content">
    <h2 class="additemhead">{{ 'complex' | translate }}</h2>

    <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <div class="form-group">
            <input class="input" type="text" formControlName="complex_name" placeholder="{{ 'complex_name' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="complex_location" placeholder="{{ 'complex_location' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="request_details" placeholder="{{ 'request_details' | translate }}" />
          </div>

    

  
       
          <div class="form-group">
            <textarea class="input" formControlName="notes" placeholder="{{ 'note' | translate }}"></textarea>
          </div>

          <div class="form-group">
            <button type="submit" class="fromsave accont" [disabled]="data.invalid">
              @if(isUpdatePage){
              {{ 'Edit' | translate }}

              }
              @else{
              {{ 'Create Client' | translate }}

              }
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>